import { render } from "./DeleteWarning.vue?vue&type=template&id=83505702"
import script from "./DeleteWarning.vue?vue&type=script&lang=js"
export * from "./DeleteWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__